import { render, staticRenderFns } from "./rating.vue?vue&type=template&id=830e395e&scoped=true&lang=html&"
import script from "./rating.vue?vue&type=script&lang=js&"
export * from "./rating.vue?vue&type=script&lang=js&"
import style0 from "./rating.vue?vue&type=style&index=0&id=830e395e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../base-image/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830e395e",
  null
  
)

export default component.exports